<mat-toolbar class="fullscreen-toolbar" color="primary">
  <mat-toolbar-row>
    <div class="toolbar-content">
      @if (!gridStore.changes) {
      <h3>{{ 'scheduler.resources.chooser.title' | translate }}</h3>
      }
      <span class="flex-spacer"></span>
      <a mat-icon-button matDialogClose="" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </a>
    </div>
  </mat-toolbar-row>

  @if (!!data) {
  <mat-toolbar-row class="checkbox-row">
    <mat-checkbox (change)="updateRequiredFilters()" [(ngModel)]="hasRequiredSkill"
      aria-label="Filter by required skills">
      Has Required Skills
    </mat-checkbox>
    <mat-checkbox (change)="updateRequiredFilters()" [(ngModel)]="hasRequiredZone" aria-label="Filter by required zone">
      Has Required Zone
    </mat-checkbox>
  </mat-toolbar-row>
  }
</mat-toolbar>

<div class="grid-container">
  <app-grid [columns]="columns" [filter]="true" [readOnly]="false" [showContextMenu]="true" [showDirty]="false"
    [store]="gridStore" [width]="'100%'"></app-grid>
</div>

<mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
  [pageIndex]="gridStore.currentPage - 1" [pageSizeOptions]="pageSizeOptions" [pageSize]="gridStore.pageSize"
  hidePageSize="false" showFirstLastButtons="true">
</mat-paginator>